import React, {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom"
import useFetch, {CachePolicies} from "use-http";
//@ts-ignore
import _ from "lodash";
import {getLinkDetail} from "src/service/files.service";
import RecentFile3 from "src/assets/png/RecentFile3.png";
import {FileContext} from "../../File.context";
import {supportViewer} from "../../properies.file";
import styles from "./LinksContainer.module.scss";
import {checkImg, getNameOfUserNotFriend} from "src/service/files.util";
import {useTranslation} from "react-i18next";
import {BgImgWithLazy} from "src/components/shared/BgImgWithLazy/BgImgWithLazy";

const defaultLitmitOfset = 30;

const UILinkItem = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [loadMore, setLoadMore] = useState(false);

  const [offsetFile, setOffsetFile]: any = useState(0);
  const [offsetFolder, setOffsetFolde]: any = useState(0);
  const fileContext: any = useContext(FileContext);

  const [isOpenImg, setIsOpenImg] = useState(false);
  const [urlPreviewImg, setUrlPreviewImg] = useState("");

  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const [urlPreviewVideo, setUrlPreviewVideo] = useState("");
  const [userOfLink, setUserOfLink] = useState({});
  const [usernameOfLink, setUsernameOfLink] = useState(props.link?.userId);

  const [urlImage, setUrlImage]: any = useState("");
  const [linkDetail, setLinkDetail]: any = useState({});
  let defaultBigSize = "40";
  let boxSizeWidth = "100px";
  let boxSizeHeight = "100px";
  useEffect(() => {
    getSetLinkDetail();
  }, []);

  const getSetLinkDetail = async () => {
    let linkDetailT: any = await getLinkDetail(props.link?.messageText);
    setLinkDetail(linkDetailT);
    testImage(linkDetailT?.mainImg);
  };

  const testImage = async (url: any) => {
    let checkImgvalue = await checkImg(url);
    if (checkImgvalue) {
      setUrlImage(url);
    } else {
      setUrlImage(RecentFile3);
    }
  };

  const clickPreviewImage = () => {};

  const handleClick = (e: any) => {
    window.open(props.link?.messageText, "_system");
  };

  // const clickLink = (row) => {
  //   window.open(props.row?.messageText, "_system");
  // };

  const apiGetUserData = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v1/users/detail`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const getUserDataOfLink = async () => {
    await apiGetUserData.get(`${props.link?.userId}`);
    setUserOfLink(apiGetUserData.response.data);
    let name = getNameOfUserNotFriend(apiGetUserData.response.data);
    console.log("name : ",name)
    console.log("apiGetUserData.response.data : ",apiGetUserData.response.data)
    setUsernameOfLink(name);
  };

  useEffect(() => {
    getUserDataOfLink();
  }, []);

  return (
    <>
      <div className={styles.boxMediaItem} onClick={handleClick}>
        {supportViewer.video.indexOf(props.file?.file_type) > -1 && (
          <div className={styles.playVideoIcon}>
            <div className={styles.playVideoIconImg}></div>
          </div>
        )}
        <div style={{ display: "flex" }}>
          <div>
            <BgImgWithLazy
              containerClassName="img"
              classPlaceholder={"img-gray"}
              src={urlImage}
              style={{
                filter: false ? "sepia(1)" : "unset",
                height: boxSizeHeight,
                width: boxSizeWidth,
                borderRadius: "0px",
              }}
            />
          </div>
          <div style={{ width: "calc(100% - 100px)", marginLeft: "8px" }}>
            <div className={styles.boxtext}>
              <div className={styles.textOverflowListFileText}>
                <div style={{ fontSize: "0.875rem" }}>{linkDetail.title}</div>
              </div>
            </div>
            <div className={styles.boxtext}>
              <div className={styles.textOverflowListFileText}>
                <div style={{ fontSize: "0.7rem", color: "#707070" }}>
                  {linkDetail.description}
                </div>
              </div>
            </div>
            <div className={styles.boxtext}>
              <div className={styles.textOverflowListFileText}>
                <div style={{ fontSize: "0.7rem", color: "#428DFF" }}>
                  {props.link?.messageText}
                </div>
              </div>
            </div>
            <div className={styles.boxtext}>
              <div className={styles.textOverflowListFileText}>
                <div style={{ fontSize: "0.7rem", color: "#AFAFAF" }}>
                  {t("Upload by ")}
                  {usernameOfLink}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UILinkItem;
